export class Business {

  public FullName: string;
  public Name: string;
  public Address: string;
  public City: string;
  public State: string;
  public Zip: string;
  public Logo: string;

  constructor() {
    this.Address = "P.O. Box 49";
    this.City = "Cuyahoga Falls";
    this.FullName = "CFYN Tigersharks";
    this.Name = "CFYN Tigersharks";
    this.State = "OH";
    this.Zip = "44221";
    this.Logo = "http://www.cfyntigersharks.com/images/tsharks_logo.gif";

  }
}



// WEBPACK FOOTER //
// ./src/app/models/business.ts